import { Customer } from "@towersystems/roam-common/lib/generated-types";
import { View } from "react-native-ui-lib";
import { Badge, Stack, Text } from "@towersystems/roam-common-native";

export interface SaleCustomerSummaryProps {
  customer: Customer;
}
export const SaleCustomerSummary = ({ customer }: SaleCustomerSummaryProps) => {
  const badgeMarkup = customer.isRetailerCusAccount ? (
    <Badge retailerCustomerAccountStatus="RETAILER_CUSTOMER_ACCOUNT" />
  ) : null;

  return (
    <View>
      <View flex row style={{ alignItems: "center" }}>
        <View flex>
          <Stack centerVertical spacing={3}>
            <Text variant="heading3">{`${customer.firstName} ${customer.lastName}`}</Text>
            {badgeMarkup}
          </Stack>
          {customer.emailAddress ? (
            <Text color="subdued">{`${customer.emailAddress}`}</Text>
          ) : undefined}
        </View>
      </View>
    </View>
  );
};
